import { Dropdown, Menu } from "antd";
import { IconCheck } from "assets/icons";
import { GALLERY_SORT_BY } from "constants/gallery";
import THEME from "constants/themes";
import GalleryContext from "contexts/Gallery";
import { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import utils from "services/utils";
import { StyledSection, StyledText } from "styled-components/CommonStyled";
import {
  StyledFlex,
  StyledIcon,
} from "styled-components/CustomGallery/CustomGalleryStyled";

const GallerySorting = () => {
  const { t } = useTranslation();
  const { requestPayload, setRequestPayload } = useContext(GalleryContext);

  const [visible, setVisible] = useState(false);

  const renderLabel = (item) => {
    return (
      <StyledFlex tabIndex={0}>
        <StyledText fontSize="16px">{item.label}</StyledText>
        {[requestPayload.sort].includes(item.key) && (
          <StyledIcon color={THEME.colors.darkBlue5}>
            <IconCheck />
          </StyledIcon>
        )}
      </StyledFlex>
    );
  };

  const menuItems = [
    {
      key: GALLERY_SORT_BY.DATE_ADDED,
      label: t("sort_by.date_added"),
    },
    {
      key: GALLERY_SORT_BY.MOST_POPULAR,
      label: t("sort_by.most_popular"),
    },
    {
      key: GALLERY_SORT_BY.MOST_VIEWED,
      label: t("sort_by.most_view"),
    },
  ];

  return (
    <StyledSection>
      <Dropdown
        overlayClassName="sorting-dropdown"
        open={visible}
        trigger={["click"]}
        menu={{
          items: menuItems.map((item) => ({
            ...item,
            label: renderLabel(item),
            tabIndex: 0,
            onClick: () => {
              setRequestPayload({ ...requestPayload, sort: item.key });
            },
          })),
        }}
        overlayStyle={{
          width: "200px",
        }}
        onOpenChange={(open) => {
          setVisible(open);
        }}
        autoFocus
      >
        <StyledSection
          tabIndex={0}
          display="flex"
          alignItems="center"
          height="42px"
          border={`1px solid ${THEME.colors.darkBlue1}`}
          padding="0 12px"
          borderRadius="12px"
          fontSize="16px"
        >
          {t("sorting_by", {
            type: t(`sort_by.${requestPayload.sort.toLowerCase()}`),
          })}
        </StyledSection>
      </Dropdown>
    </StyledSection>
  );
};

export default GallerySorting;
